import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 The Age-in-Place Blueprint™ (6 Volumes, 200+ pages)',
  price: '$27'
}, {
  label: '🎁 Bonus #1: The Smart-Kitchen Guide 60+',
  price: 'FREE'
}, {
  label: '🎁 Bonus #2: The Legacy Binder',
  price: 'FREE'
}, {
  label: '🎁 Bonus #3: The Fall-Proof Home Audit',
  price: 'FREE'
}, {
  label: '🎁 Bonus #4: The 5-Minute Caregiver Relief',
  price: 'FREE'
}, {
  label: '🎁 Bonus #5: The Emergency Responder Dashboard',
  price: 'FREE'
}, {
  label: '🛡️ 7-Day Money-Back Guarantee',
  price: 'INCLUDED'
}, {
  label: '♾️ Lifetime access & free updates',
  price: 'INCLUDED'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Delivery'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Credit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" className="border-y border-grape/10 bg-white/70" data-id="element-207" data-mp="1telc4ig3t0ko">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" style={{
      paddingTop: "13px",
      paddingBottom: "25px"
    }} data-id="element-208" data-mp="1oh1mynhvb3dy">
        <h2 className="font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-209" data-mp="235y2t6q61kp4">
          🚀 Start Maintaining Your Parent's Independence In 30 Days
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-plum/60" data-id="element-210" data-mp="2c5kw158qrk73">
          Assess properly, prescribe daily protocols and prevent hospitalization safely. One single
          payment, lifetime access, everything ready to start today.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-grape/15 bg-cream text-left" data-id="element-211" data-mp="2m3ijvrmovez6">
          <div className="flex items-center justify-between border-b border-grape/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-plum/55" data-id="element-212" data-mp="2h5qqsuab5mte">
            <span data-id="element-213" data-mp="mrg0sihz8mm1">What's included</span>
            <span data-id="element-214" data-mp="mshekuqdnn7g">Price</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-grape/10 px-5 py-3.5 text-sm" data-id="element-215" data-mp="2mtpas64wwp4z">
              <span className="text-plum/80" data-id="element-216" data-mp="2rt21j1ywmgcu">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-plum' : 'shrink-0 font-bold text-grape'} data-id="element-217" data-mp="2vtcfp1wuod2s">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-col items-center gap-1 bg-lilac-soft px-5 py-6 text-center" data-id="element-218" data-mp="35s1qkaqbwx9j">
            <span className="text-sm font-bold text-plum" style={{
            fontSize: "16px"
          }} data-id="element-219" data-mp="3ar4qjgrgcdan">
              Real total value: <span className="text-plum/40 line-through" data-id="element-220" data-mp="3fhl6p8mnqd0p">$209</span>
            </span>
            <span className="text-grape-shine font-display text-5xl font-black leading-none sm:text-6xl" style={{
            fontSize: "64px",
            fontFamily: "Montserrat, sans-serif",
            paddingTop: "8px",
            paddingBottom: "11px"
          }} data-id="element-221" data-mp="3jj6o97a4zfh8">
              $27
            </span>
            <span className="text-xs font-semibold uppercase tracking-wide text-plum/60" data-id="element-222" data-mp="7g5apgb7osly">
              USD · One-time payment
            </span>
            <span className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-223" data-mp="2gapnte4ax8t">
              Payment will be processed in your local currency.
            </span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-224" data-mp="3pmtixf1k5vvu">
          <CTAButton data-id="element-225" data-mp="3po4mpev073my">Get The Age-in-Place Blueprint™</CTAButton>
        </div>

        <p className="mt-3 text-xs font-semibold text-plum/55" data-id="element-226" data-mp="q5v5w4ivzgee">
          You save $182 USD (87% OFF) · One-time payment
        </p>
        

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-227" data-mp="gglc8k8e9po6">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-228" data-mp="cdf9hmkhqgmg">
              <Icon className="h-4 w-4 text-grape" data-id="element-229" data-mp="18yfn2op83x2d" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}